/**
 * @type {Object}
 * @property {array}  data  Item data
 */
const initialState = {
    customerComplaintsData: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerComplain = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_COMPLAINS':
            var { data } = action;
            newState.customerComplaintsData = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerComplain;